import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ContractAppService from '../../../../application/platform/scp/contract/contract-app-service';
import { ACTION_TYPES, useAmendmentListDispatch, useAmendmentListState } from './amendment-list-context';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useAmendmentListController = () => {
    const navigate = useNavigate();
    const { showLoading, showMessage } = useBaseLayout();
    const dispatch = useAmendmentListDispatch();
    const state = useAmendmentListState();

    useEffect(() => {
        loadInitialData();
    }, [state.contractId]);

    async function loadInitialData() {
        try {
            showLoading({ open: true });

            if (state.contractId !== undefined && state.contractId !== null) {
                const data = await ContractAppService.getContract(state.contractId);
                dispatch({ type: ACTION_TYPES.setProcessNumber, payload: data.processNumber });
            }

            showLoading({ open: false });
        } catch (error) {
            showMessage({
                open: true,
                message: 'Não foi possível carregar as informações do contrato',
                detail: (error as any).details || (error as Error).message,
                type: 'error'
            });
            showLoading({ open: false });
        }
    }

    function navigateToCreate() {
        navigate(`/contratos/${state.contractId}/aditivos/publicar`);
    }

    return {
        navigateToCreate
    };
}
